
import ActionsForm from '@/shared/mixins/actionsForm'
import tableOcorrencia from '../tabla/table.vue'

export default {
  name: 'collapseOcorrencia',
  props: [],
  mixins: [ActionsForm],
  components: {tableOcorrencia},
  data () {
    return {
      tabs: 0,
      tabIndex: 0,
      tecnico: 1,
      engenheiro: 0,
      formSearch: {},
      openSections: []
    }
  },
  watch: {
    'tabIndex' (newValue) {
      if (newValue !== null) {
        this.chamarTable(newValue)
      }
    }
  },
  methods: {
    chamarTable () {
      if (this.tabIndex === 0) {
        this.$refs.tableEngenheiro.formSearch = this.formSearch
        this.$refs.tableEngenheiro.onLoadTable(this.engenheiro)
      } else {
        this.$refs.tableTecnico.formSearch = this.formSearch
        this.$refs.tableTecnico.onLoadTable(this.tecnico)
      }
    },
    chamarTableAba (value) {
      if (value === 0) {
        this.$refs.tableEngenheiro.formSearch = {}
        this.$refs.tableEngenheiro.onLoadTable(this.engenheiro)
      } else {
        this.$refs.tableTecnico.formSearch = {}
        this.$refs.tableTecnico.onLoadTable(this.tecnico)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/occurrenceMaintenance/components/colapse/colapse.js